var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 5.86667C13.8775 5.86667 15.1442 6.67778 15.8664 7.35556L18.6886 4.6C16.9553 2.98889 14.6997 2 11.9997 2C8.08863 2 4.71085 4.24444 3.06641 7.51111L6.29974 10.0222C7.11085 7.61111 9.3553 5.86667 11.9997 5.86667V5.86667Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 12.2222C21.6 11.4 21.5333 10.8 21.3889 10.1778H12V13.8889H17.5111C17.4 14.8111 16.8 16.2 15.4667 17.1333L18.6222 19.5778C20.5111 17.8333 21.6 15.2667 21.6 12.2222V12.2222Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31111 13.9778C6.1 13.3556 5.97778 12.6889 5.97778 12C5.97778 11.3111 6.1 10.6444 6.3 10.0222L3.06667 7.51111C2.38889 8.86666 2 10.3889 2 12C2 13.6111 2.38889 15.1333 3.06667 16.4889L6.31111 13.9778V13.9778Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 22C14.7001 22 16.9668 21.1111 18.6223 19.5778L15.4668 17.1333C14.6223 17.7222 13.489 18.1333 12.0001 18.1333C9.35566 18.1333 7.11121 16.3889 6.31121 13.9778L3.07788 16.4889C4.72233 19.7556 8.08899 22 12.0001 22V22Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGoogle);
export default __webpack_public_path__ + "static/media/ico-google.8e11c7c784c19f3289861601e5026d5e.svg";
export { ForwardRef as ReactComponent };